import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { getContentAccessTypeTagI18nKeyFromAccessControlType } from 'ui-memberships-settings-lib/utils/contentAccessTypeTag';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, useAuthInfoProvider, getContentStatusType, contentIsPublishedWithScheduledUpdate, contentIsArchived } from 'content-management-data-lib';
import { getHasUserScope } from '../../utils/userInfoUtils';
import { contentIsDeleted, getContentAccessControlType } from '../../utils/contentObjectUtils';
import ContentApprovalStatusTag from './ContentApprovalStatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AudienceAccessStatusTag = ({
  contentAccessControlType,
  hasAudienceAccess
}) => {
  if (!hasAudienceAccess) {
    return null;
  }
  const i18nKey = getContentAccessTypeTagI18nKeyFromAccessControlType(contentAccessControlType);
  return /*#__PURE__*/_jsx(Tag, {
    use: "default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey
    })
  });
};
export const ContentStatusTag = ({
  contentStatus,
  securityState,
  isPublishedWithScheduledUpdate = false,
  isContentDeleted = false,
  showAdditionalArchivedTag = false
}) => {
  const tagLangKey = contentStatus === 'danger' ? securityState : contentStatus;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tag, {
      "data-test-id": "content-status-tag",
      use: contentStatus,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `content-management-details-lib.header.contentStatusTag.${tagLangKey}`
      })
    }), isPublishedWithScheduledUpdate && /*#__PURE__*/_jsx(Tag, {
      "data-test-id": "published-with-scheduled-update-tag",
      use: "scheduled",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.header.contentStatusTag.publishedWithScheduledUpdate"
      })
    }), showAdditionalArchivedTag && /*#__PURE__*/_jsx(Tag, {
      "data-test-id": "archived-tag",
      use: "default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.header.contentStatusTag.archived"
      })
    }), isContentDeleted && /*#__PURE__*/_jsx(Tag, {
      "data-test-id": "deleted-tag",
      use: "danger",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.header.contentStatusTag.deleted"
      })
    })]
  });
};
export const ContentStatusTags = ({
  contentObject,
  additionalStatusTags
}) => {
  const {
    userInfo,
    getIsUngatedToUseResolvedStateProperty
  } = useAuthInfoProvider();
  const isUngatedToUseResolvedStateProperty = getIsUngatedToUseResolvedStateProperty();
  const contentStatus = getContentStatusType(contentObject, isUngatedToUseResolvedStateProperty);
  const securityState = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.SECURITY_STATE);
  const isContentDeleted = contentIsDeleted(contentObject);
  const isPublishedWithScheduledUpdate = contentIsPublishedWithScheduledUpdate(contentObject, isUngatedToUseResolvedStateProperty);
  const archived = contentIsArchived(contentObject);
  const contentAccessControlType = getContentAccessControlType(contentObject);
  const hasAudienceAccess = getHasUserScope(userInfo, 'marketing-content-restricted-write');
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    "data-test-id": "tags-container",
    direction: "row",
    justify: "start",
    wrap: "nowrap",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsx(ContentStatusTag, {
      contentStatus: contentStatus,
      isContentDeleted: isContentDeleted,
      isPublishedWithScheduledUpdate: isPublishedWithScheduledUpdate,
      securityState: securityState,
      showAdditionalArchivedTag: archived
    }), /*#__PURE__*/_jsx(AudienceAccessStatusTag, {
      contentAccessControlType: contentAccessControlType,
      hasAudienceAccess: hasAudienceAccess
    }), /*#__PURE__*/_jsx(ContentApprovalStatusTag, {
      contentObject: contentObject
    }), additionalStatusTags && additionalStatusTags.map(TagComponent => {
      return /*#__PURE__*/_jsx(TagComponent, {
        contentObject: contentObject
      }, TagComponent.name);
    })]
  });
};